import Nullstack from 'nullstack';
export default function IconPlugConnected({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-plug-connected",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
  }), "   ", Nullstack.element("path", {
    d: "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
  }), "   ", Nullstack.element("path", {
    d: "M3 21l2.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M18.5 5.5l2.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M10 11l-2 2"
  }), "   ", Nullstack.element("path", {
    d: "M13 14l-2 2"
  }), " ");
}